<template>
    <div :class="['content', {'show': !isTop && show}]">
        <base-button padding="16px" background="var(--white-color)" @click="up()">
            <svg width="24px" height="24px" fill="#bbb">
                <use xlink:href="../../assets/images/sprite.svg#angle"></use>
            </svg>
        </base-button>
    </div>
</template>

<script>
    export default {
        name: "page-up",
        props: {
            show: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                isTop: true
            }
        },
        mounted() {
            window.addEventListener("scroll", this.scroll);
            this.checkTop()
        },
        methods: {
            up() {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                })
            },
            checkTop() {
                this.isTop = window.pageYOffset < 100
            },
            scroll() {
                this.checkTop()
            }
        },
        beforeDestroy() {
            window.removeEventListener("scroll", this.scroll);
        }
    }
</script>

<style scoped>
    .content {
        position: fixed;
        bottom: 0;
        right: 13px;
        transform: translateY(120%);
        transition: .4s;
        z-index: -1;
    }
    .content.show {
        bottom: 28px;
        transform: translateY(0);
        z-index: 999;
    }
    .content img,
    .content svg {
        transform: rotate(90deg);
    }
    .content /deep/.base-button {
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
    .content /deep/.base-button,
    .content /deep/.base-button .hover-effect {
        border-radius: 50%;
    }
</style>
